/* Flueshop (Wave Aceleradora) — interações do tema */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const T = window.theme || {};

  /* ---------- Dinheiro ---------- */
  function formatMoney(cents, format = T.moneyFormat || 'R$ {{amount_with_comma_separator}}') {
    const value = (Number(cents) || 0) / 100;
    const fmt = (n, dec, thou, sep) => {
      const [i, d] = n.toFixed(dec).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (d ? sep + d : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount': return fmt(value, 2, ',', '.');
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_comma_separator':
        default: return fmt(value, 2, '.', ',');
      }
    });
  }
  const toast = (msg) => {
    let t = document.getElementById('BpToast');
    if (!t) { t = document.createElement('div'); t.id = 'BpToast'; t.className = 'bp-toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._hide);
    t._hide = setTimeout(() => t.classList.remove('is-on'), 4000);
  };
  const pixPrice = (cents) => Math.floor(cents * (100 - (T.pixDiscount || 0)) / 100);
  function installments(cents) {
    let n = T.installments || 1;
    if (T.installmentMin > 0) n = Math.min(n, Math.floor(cents / T.installmentMin));
    n = Math.max(1, n);
    return n > 1 ? `${n}x de ${formatMoney(Math.floor(cents / n))}` : '';
  }

  /* ---------- Drawers (carrinho, filtros, menu) ---------- */
  let lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('drawer-open');
    document.documentElement.style.overflow = 'hidden';
    const focusable = el.querySelector('button, a, input');
    if (focusable) setTimeout(() => focusable.focus(), 50);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .mobile-menu.is-open')) { document.documentElement.style.overflow = ''; document.body.classList.remove('drawer-open'); }
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); openDrawer(document.getElementById(opener.dataset.drawerOpen)); return; }
    const closer = e.target.closest('[data-drawer-close], [data-menu-close]');
    if (closer) closeDrawer(closer.closest('.drawer, .mobile-menu'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('.drawer.is-open, .mobile-menu.is-open').forEach(closeDrawer);
  });

  /* ---------- Header ---------- */
  const header = $('[data-header]');
  if (header) {
    const menuBtn = $('[data-menu-open]');
    if (menuBtn) menuBtn.addEventListener('click', () => openDrawer($('[data-mobile-menu]')));

    const searchBtn = $('[data-search-toggle]');
    const search = $('[data-search]');
    if (searchBtn && search) {
      const fields = $$('input, button', search);
      const setSearch = (open) => {
        search.classList.toggle('is-open', open);
        header.classList.toggle('search-open', open);
        search.setAttribute('aria-hidden', String(!open));
        searchBtn.setAttribute('aria-expanded', String(open));
        fields.forEach((f) => { if (f.type !== 'hidden') f.tabIndex = open ? 0 : -1; });
        if (open) setTimeout(() => $('input[type="search"]', search).focus(), 250);
      };
      searchBtn.addEventListener('click', () => setSearch(!search.classList.contains('is-open')));
      $('[data-search-close]', search).addEventListener('click', () => { setSearch(false); searchBtn.focus(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && search.classList.contains('is-open')) setSearch(false); });
      document.addEventListener('click', (e) => { if (search.classList.contains('is-open') && !search.contains(e.target) && !searchBtn.contains(e.target)) setSearch(false); });
    }

    /* Some ao descer, volta ao subir (opcional) · diminui ao rolar (opcional) */
    const hideOnScroll = header.dataset.hideOnScroll !== 'false';
    const shrink = header.classList.contains('hdr-shrink') || header.classList.contains('hdr-collapse');
    let lastY = window.scrollY;
    let ticking = false;
    const onHeaderScroll = () => {
      const y = window.scrollY;
      if (shrink) header.classList.toggle('is-compact', y > 40);
      if (hideOnScroll) {
        const busy = header.classList.contains('search-open') || header.matches(':hover') || $('.drawer.is-open, .mobile-menu.is-open');
        if (y > 180 && y > lastY + 6 && !busy) document.body.classList.add('header-hidden');
        else if (y < lastY - 6 || y <= 180) document.body.classList.remove('header-hidden');
      }
      lastY = y;
      ticking = false;
    };
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(onHeaderScroll);
    }, { passive: true });
    onHeaderScroll();

    if (header.classList.contains('is-sticky') && document.body.classList.contains('header-overlay')) {
      const onScroll = () => header.classList.toggle('is-scrolled', window.innerWidth > 989 && window.scrollY > 260);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* ---------- Barra de anúncios rotativa ---------- */
  $$('[data-announcement]').forEach((bar) => {
    const items = $$('.announcement__item', bar);
    if (items.length < 2) return;
    let i = 0;
    let timer = null;
    const show = (n) => {
      const prev = items[i];
      i = (n + items.length) % items.length;
      if (prev === items[i]) return;
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      setTimeout(() => prev.classList.remove('is-leaving'), 460);
      items[i].classList.add('is-active');
    };
    const start = () => { clearInterval(timer); timer = setInterval(() => show(i + 1), Number(bar.dataset.speed) || 4000); };
    const prevBtn = $('[data-ann-prev]', bar);
    const nextBtn = $('[data-ann-next]', bar);
    if (prevBtn) prevBtn.addEventListener('click', () => { show(i - 1); start(); });
    if (nextBtn) nextBtn.addEventListener('click', () => { show(i + 1); start(); });
    bar.addEventListener('mouseenter', () => clearInterval(timer));
    bar.addEventListener('mouseleave', start);
    start();
  });

  /* ---------- Hero slider ---------- */
  $$('[data-hero]').forEach((hero) => {
    const track = $('[data-hero-track]', hero);
    const slides = $$('.hero__slide', track);
    const dots = $$('[data-hero-dot]', hero);
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    const delay = Number(hero.dataset.autoplay) || 0;

    const goTo = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
      if (!('onscrollend' in window)) restartBar();
    };
    let shown = 0;
    const sync = () => {
      index = Math.round(track.scrollLeft / track.clientWidth);
      if (index === shown) return;
      shown = index;
      dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
      slides.forEach((s, i) => s.classList.toggle('is-active', i === index));
    };
    const restartBar = () => { hero.classList.remove('is-playing'); void hero.offsetWidth; if (delay > 0) hero.classList.add('is-playing'); };
    const start = () => { if (delay > 0) { stop(); hero.classList.remove('is-paused'); timer = setInterval(() => goTo(index + 1), delay); restartBar(); } };
    const stop = () => { clearInterval(timer); hero.classList.add('is-paused'); };
    if ('onscrollend' in window) track.addEventListener('scrollend', () => { if (!hero.classList.contains('is-paused')) start(); });

    $('[data-hero-prev]', hero).addEventListener('click', () => { goTo(index - 1); start(); });
    $('[data-hero-next]', hero).addEventListener('click', () => { goTo(index + 1); start(); });
    dots.forEach((d) => d.addEventListener('click', () => { goTo(Number(d.dataset.heroDot)); start(); }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    hero.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    start();
  });

  /* ---------- Vídeos com produto ---------- */
  $$('[data-vshop]').forEach((section) => {
    const rail = $('[data-vs-rail]', section);
    if (!rail) return;
    const saveData = (navigator.connection && navigator.connection.saveData) || window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const setupStories = (root) => {
      $$('[data-vs-story]', root).forEach((media) => {
        const video = $('video', media);
        if (!video || media.dataset.ready) return;
        media.dataset.ready = '1';
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!video.src && !saveData) video.src = video.dataset.src;
              if (video.src) video.play().then(() => media.classList.add('is-playing')).catch(() => {});
            } else if (video.src) {
              video.pause();
            }
          });
        }, { rootMargin: '200px 0px', threshold: 0.35 });
        io.observe(media);
        const mute = $('[data-vs-mute]', media);
        if (mute) mute.addEventListener('click', () => {
          if (!video.src) video.src = video.dataset.src;
          video.muted = !video.muted;
          mute.setAttribute('aria-pressed', String(video.muted));
          mute.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Desativar som');
          video.play().then(() => media.classList.add('is-playing')).catch(() => {});
        });
      });
    };

    section.addEventListener('click', (e) => {
      const buy = e.target.closest('[data-vs-buy]');
      if (!buy) return;
      const prod = buy.closest('.vcard__prod');
      $$('.vcard__prod.is-open', section).forEach((p) => { if (p !== prod) p.classList.remove('is-open'); });
      prod.classList.toggle('is-open');
      buy.setAttribute('aria-expanded', prod.classList.contains('is-open'));
    });

    const step = () => (rail.children[0] ? rail.children[0].getBoundingClientRect().width + 16 : 300);
    let hold = 0;
    const pause = (ms) => { hold = performance.now() + ms; };
    const prev = $('[data-vs-prev]', section);
    const next = $('[data-vs-next]', section);
    if (prev) prev.addEventListener('click', () => { pause(2500); rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', () => { pause(2500); rail.scrollBy({ left: step(), behavior: 'smooth' }); });

    const cards = Array.from(rail.children);
    if (section.dataset.autoplay === 'true' && cards.length > 1 && !saveData && rail.scrollWidth > rail.clientWidth + 4) {
      cards.forEach((card) => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        $$('a, button, video', clone).forEach((el) => el.setAttribute('tabindex', '-1'));
        $$('[data-vs-story]', clone).forEach((m) => { delete m.dataset.ready; m.classList.remove('is-playing'); });
        rail.appendChild(clone);
      });
      section.dataset.auto = 'on';
      const loopWidth = () => rail.children[cards.length].offsetLeft - rail.children[0].offsetLeft;
      const speed = Number(section.dataset.speed) || 35;
      const state = { hover: false, view: true };
      let pos = -1;
      let last = 0;
      let lastSet = -1;
      rail.addEventListener('pointerenter', (ev) => { if (ev.pointerType === 'mouse') state.hover = true; });
      rail.addEventListener('pointerleave', (ev) => { if (ev.pointerType === 'mouse') state.hover = false; });
      ['wheel', 'touchstart', 'pointerdown'].forEach((t) => rail.addEventListener(t, () => pause(1800), { passive: true }));
      rail.addEventListener('scroll', () => { if (lastSet >= 0 && Math.abs(rail.scrollLeft - lastSet) > 2) { pause(1500); pos = -1; } }, { passive: true });
      new IntersectionObserver((en) => { state.view = en[0].isIntersecting; }).observe(rail);
      const frame = (now) => {
        requestAnimationFrame(frame);
        if (state.hover || !state.view || document.hidden || now < hold || $('.vcard__prod.is-open', section)) { last = 0; lastSet = -1; return; }
        if (!last) { last = now; return; }
        const dt = Math.min((now - last) / 1000, 0.12);
        last = now;
        if (pos < 0) pos = rail.scrollLeft;
        pos += speed * dt;
        const lw = loopWidth();
        if (lw > 0) while (pos >= lw) pos -= lw;
        rail.scrollLeft = pos;
        lastSet = rail.scrollLeft;
      };
      requestAnimationFrame(frame);
    }
    setupStories(section);
  });

  /* ---------- Faixa de categorias ---------- */
  $$('.catstrip').forEach((sec) => {
    const rail = $('[data-strip]', sec);
    const by = () => (rail.children[0] ? (rail.children[0].getBoundingClientRect().width + 14) * 2 : 300);
    const p = $('[data-strip-prev]', sec);
    const n = $('[data-strip-next]', sec);
    if (p) p.addEventListener('click', () => rail.scrollBy({ left: -by(), behavior: 'smooth' }));
    if (n) n.addEventListener('click', () => rail.scrollBy({ left: by(), behavior: 'smooth' }));
  });

  /* ---------- Benefícios (mobile: um por vez) ---------- */
  $$('[data-benefits]').forEach((list) => {
    const items = $$('.benefit', list);
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      if (window.innerWidth > 989) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 3000);
  });

  /* ---------- Carrosséis ---------- */
  function initCarousel(root) {
    const track = $('[data-carousel-track]', root);
    const prev = $(':scope > [data-carousel-prev]', root);
    const next = $(':scope > [data-carousel-next]', root);
    if (!track) return;
    const update = () => {
      root.classList.toggle('is-static', track.scrollWidth <= track.clientWidth + 2);
      const max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    };
    const step = () => {
      const first = track.children[0];
      if (!first) return track.clientWidth;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const card = first.getBoundingClientRect().width + gap;
      return Math.max(card, Math.floor(track.clientWidth / card) * card);
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  $$('[data-carousel]').forEach(initCarousel);

  /* ---------- Galeria do produto ---------- */
  $$('[data-product]').forEach((section) => {
    const track = $('[data-gallery] [data-carousel-track]', section);
    const thumbs = $$('[data-thumb]', section);
    const thumbList = $('[data-thumbs]', section);
    if (!track) return;
    const slides = $$('.gallery__slide', track);
    const scrollToSlide = (i) => {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    };
    const dots = $$('[data-gallery-dots] span', section);
    const setActive = (i) => {
      thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      const active = thumbs[i];
      if (active && thumbList) thumbList.scrollTo({ top: active.offsetTop - thumbList.offsetTop - 40, behavior: 'smooth' });
    };
    thumbs.forEach((t) => t.addEventListener('click', () => { const i = Number(t.dataset.thumb); scrollToSlide(i); setActive(i); }));
    track.addEventListener('scroll', () => requestAnimationFrame(() => {
      const w = slides[0] ? slides[0].getBoundingClientRect().width : 1;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      setActive(Math.round(track.scrollLeft / (w + gap)));
    }), { passive: true });
    const up = $('[data-thumbs-up]', section);
    const down = $('[data-thumbs-down]', section);
    if (up) up.addEventListener('click', () => thumbList.scrollBy({ top: -200, behavior: 'smooth' }));
    if (down) down.addEventListener('click', () => thumbList.scrollBy({ top: 200, behavior: 'smooth' }));
    section._scrollToMedia = (mediaId) => {
      const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
      if (i >= 0) { scrollToSlide(i); setActive(i); }
    };
  });

  /* ---------- Variantes e compra ---------- */
  $$('[data-product]').forEach((section) => {
    const jsonEl = $('[data-product-json]', section);
    const form = $('[data-product-form]', section);
    if (!jsonEl || !form) return;
    const data = JSON.parse(jsonEl.textContent);
    const idInput = $('[data-variant-id]', form);
    const btn = $('[data-add-to-cart]', form);
    const label = $('[data-add-label]', form);
    const errorEl = $('[data-form-error]', section);
    const fieldsets = $$('[data-option-index]', form);

    const selected = () => fieldsets.map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });

    const refreshAvailability = () => {
      const current = selected();
      fieldsets.forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const probe = current.slice();
          probe[idx] = input.value;
          const ok = data.variants.some((v) => v.available && probe.every((val, k) => val === null || v.options[k] === val));
          input.closest('.product-option__value').classList.toggle('is-unavailable', !ok);
        });
      });
    };

    const onChange = () => {
      const opts = selected();
      fieldsets.forEach((fs) => { const c = $('input:checked', fs); const s = $('[data-option-selected]', fs); if (c && s) s.textContent = c.value; });
      const variant = data.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      refreshAvailability();
      if (!variant) {
        btn.disabled = true;
        label.textContent = 'Indisponível';
        return;
      }
      idInput.value = variant.id;
      btn.disabled = !variant.available;
      label.textContent = variant.available ? data.buttonLabel : 'Esgotado';

      const main = $('[data-price-main]', section);
      const compare = $('[data-price-compare]', section);
      const inst = $('[data-price-installments]', section);
      if (main) main.textContent = formatMoney(pixPrice(variant.price));
      if (compare) {
        compare.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = formatMoney(variant.compare_at_price);
      }
      if (inst) {
        const parts = installments(variant.price);
        inst.innerHTML = T.pixDiscount > 0
          ? `ou <strong>${formatMoney(variant.price)}</strong> no cartão${parts ? ` em até <strong>${parts}</strong> sem juros` : ''}`
          : (parts ? `em até <strong>${parts}</strong> sem juros no cartão` : '');
      }
      const stock = $('[data-stock]', section);
      if (stock) {
        // Metacampo alertar_estoque manda no número mostrado (sem passar do estoque real)
        let showQty = 0;
        if (variant.available && variant.qty !== null && variant.qty > 0) {
          if (variant.alert > 0) showQty = Math.min(variant.qty, variant.alert);
          else if (variant.qty <= data.lowStock) showQty = variant.qty;
        }
        if (!variant.available) stock.innerHTML = '<span class="stock__dot stock__dot--out"></span>Esgotado neste tamanho';
        else if (showQty > 0) {
          const msg = showQty === 1 ? 'Corra, resta apenas 1 item em estoque!' : `Corra, restam apenas ${showQty} itens em estoque!`;
          stock.innerHTML = `<span class="stock__urgent">${msg}</span><span class="stock__bar"><i style="width: ${Math.max(4, Math.min(100, Math.round(showQty * 100 / 30)))}%"></i></span>`;
        } else stock.innerHTML = `<span class="stock__dot"></span>${T.stockText || 'Pronta entrega'}`;
      }
      $$('[data-cashback]', section).forEach((el) => {
        el.textContent = formatMoney(Math.round(variant.price * Number(el.dataset.cashback) / 100));
      });
      const sp = $('[data-sticky-price]', section);
      const sv = $('[data-sticky-variant]', section);
      if (sp) sp.textContent = formatMoney(pixPrice(variant.price));
      if (sv) sv.textContent = opts.join(' / ');
      if (variant.media_id && section._scrollToMedia) section._scrollToMedia(variant.media_id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    };
    fieldsets.forEach((fs) => fs.addEventListener('change', onChange));
    if (fieldsets.length) refreshAvailability();

    const sticky = $('[data-sticky-buy]', section);
    if (sticky && 'IntersectionObserver' in window) {
      const st = { past: false, footer: false };
      const apply = () => {
        const show = st.past && !st.footer;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        document.body.classList.toggle('has-sticky-buy', show);
      };
      new IntersectionObserver(([entry]) => {
        st.past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        apply();
      }).observe(btn);
      const footer = $('.footer');
      if (footer) new IntersectionObserver(([entry]) => { st.footer = entry.isIntersecting; apply(); }, { rootMargin: '0px 0px -40px 0px' }).observe(footer);
      $('[data-sticky-add]', sticky).addEventListener('click', () => {
        if (btn.disabled) { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        form.requestSubmit ? form.requestSubmit() : btn.click();
      });
    }

    const qtyInput = $('[data-qty-input]', form);
    if (qtyInput) {
      $('[data-qty-minus]', form).addEventListener('click', () => { qtyInput.value = Math.max(1, Number(qtyInput.value) - 1); });
      $('[data-qty-plus]', form).addEventListener('click', () => { qtyInput.value = Number(qtyInput.value) + 1; });
    }

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      errorEl.hidden = true;
      btn.classList.add('is-loading');
      try {
        await Cart.add([{ id: Number(idInput.value), quantity: qtyInput ? Number(qtyInput.value) : 1 }]);
        Cart.open();
      } catch (err) {
        errorEl.textContent = err.message;
        errorEl.hidden = false;
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  });

  /* ---------- Aviso de combo (lado esquerdo) ---------- */
  const Nudge = {
    get el() { return document.getElementById('PromoNudge'); },
    key: 'bp-nudge-min',
    init() {
      const el = this.el;
      if (!el) return;
      const card = el.querySelector('[data-pp-state]');
      let minState = null;
      try { minState = sessionStorage.getItem(this.key); } catch (_) {}
      // No celular começa recolhido (pílula); no computador, aberto — a não ser que a cliente tenha minimizado.
      if ((card && minState === card.dataset.ppState) || window.innerWidth < 750) el.classList.add('is-min');
    },
    isMobile() { return window.innerWidth < 750; },
    autoClose(ms) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => { if (this.isMobile() && this.el) this.el.classList.add('is-min'); }, ms);
    },
    async update(html) {
      const el = this.el;
      if (!el) return;
      if (!html) {
        const res = await fetch(`${window.location.pathname}?sections=promo-nudge`, { headers: { Accept: 'application/json' } });
        html = (await res.json())['promo-nudge'];
      }
      const fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('PromoNudge');
      if (!fresh) return;
      const before = el.querySelector('[data-pp-state]');
      const after = fresh.querySelector('[data-pp-state]');
      const changed = (before && before.dataset.ppState) !== (after && after.dataset.ppState);
      el.innerHTML = fresh.innerHTML;
      if (changed && after) {
        if (window.innerWidth >= 750) {
          el.classList.remove('is-min');
        } else {
          // Celular: mostra o progresso por alguns segundos e volta para o círculo.
          el.classList.remove('is-min');
          this.autoClose(3500);
        }
        el.classList.add('is-bump');
        setTimeout(() => el.classList.remove('is-bump'), 700);
      }
    }
  };
  document.addEventListener('click', (e) => {
    const el = Nudge.el;
    if (!el || !el.contains(e.target)) return;
    const card = el.querySelector('[data-pp-state]');
    if (e.target.closest('[data-nudge-close]')) {
      el.classList.add('is-min');
      try { if (card) sessionStorage.setItem(Nudge.key, card.dataset.ppState); } catch (_) {}
    }
    if (e.target.closest('[data-open-combos]')) {
      Cart.forceCombos = true;
      Cart.open();
      Cart.refresh();
      return;
    }
    if (e.target.closest('[data-nudge-open]')) {
      clearTimeout(Nudge.timer);
      el.classList.remove('is-min');
      try { sessionStorage.removeItem(Nudge.key); } catch (_) {}
    }
  });
  Nudge.init();
  // Celular: card aberto fecha ao rolar a página ou tocar fora dele.
  let nudgeScrollY = window.scrollY;
  window.addEventListener('scroll', () => {
    const el = Nudge.el;
    if (!el || !Nudge.isMobile() || el.classList.contains('is-min')) { nudgeScrollY = window.scrollY; return; }
    if (Math.abs(window.scrollY - nudgeScrollY) > 60) { el.classList.add('is-min'); clearTimeout(Nudge.timer); }
  }, { passive: true });
  document.addEventListener('click', (e) => {
    const el = Nudge.el;
    if (!el || !Nudge.isMobile() || el.classList.contains('is-min') || el.contains(e.target)) return;
    el.classList.add('is-min');
    clearTimeout(Nudge.timer);
  });
  document.addEventListener('click', (e) => { if (e.target.closest('[data-nudge-open]')) nudgeScrollY = window.scrollY; }, true);
  // Página reaberta pelo "voltar" (cache do navegador) ou sacola alterada em outra aba: atualiza combos e contador.
  const resync = () => { if (window.BasicCart) window.BasicCart.refresh(); else Nudge.update(); };
  window.addEventListener('pageshow', (e) => { if (e.persisted) resync(); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) resync(); });

  /* ---------- Sacola lateral (renderizada pela Shopify) ---------- */
  const Cart = {
    get drawer() { return document.getElementById('CartDrawer'); },
    async render(sectionsJson) {
      let html = sectionsJson && sectionsJson['cart-drawer'];
      if (!html) {
        const res = await fetch(`${window.location.pathname}?sections=cart-drawer`, { headers: { Accept: 'application/json' } });
        html = (await res.json())['cart-drawer'];
      }
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('.cart-drawer__panel');
      const panel = this.drawer && this.drawer.querySelector('.cart-drawer__panel');
      if (fresh && panel) {
        const scroll = panel.querySelector('.cd-body') ? panel.querySelector('.cd-body').scrollTop : 0;
        const combosOpen = this.forceCombos || (panel.querySelector('.cd-combos') && panel.querySelector('.cd-combos').open);
        this.forceCombos = false;
        panel.innerHTML = fresh.innerHTML;
        const combos = panel.querySelector('.cd-combos');
        if (combos && combosOpen) combos.open = true;
        const body = panel.querySelector('.cd-body');
        if (body) body.scrollTop = scroll;
      }
      Nudge.update(sectionsJson && sectionsJson['promo-nudge']);
      const count = doc.querySelector('.cd-head__count');
      if (count) $$('[data-cart-count]').forEach((el) => { el.textContent = count.textContent.trim(); });
      document.dispatchEvent(new CustomEvent('cart:rendered'));
    },
    async refresh() { await this.render(); },
    async add(items) {
      const res = await fetch(T.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items, sections: 'cart-drawer,promo-nudge', sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) throw new Error(json.description || json.message || 'Não foi possível adicionar.');
      await this.render(json.sections);
      return json;
    },
    // Kit (fl-lp): todas as linhas com o mesmo _kit_id saem juntas — peças e brinde
    async removeKit(kitId) {
      const updates = {};
      $$('[data-kit]', this.drawer).forEach((el) => { if (el.dataset.kit === kitId) updates[el.dataset.key] = 0; });
      const res = await fetch(T.routes.cart + '/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections: 'cart-drawer,promo-nudge', sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) { toast(json.description || json.message || 'Não foi possível remover o kit.'); await this.render(); return; }
      await this.render(json.sections);
    },
    async change(key, quantity) {
      const res = await fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: 'cart-drawer,promo-nudge', sections_url: window.location.pathname })
      });
      const json = await res.json();
      if (!res.ok) { toast(json.description || json.message || 'Não foi possível alterar a quantidade.'); await this.render(); return; }
      await this.render(json.sections);
    },
    open() { openDrawer(this.drawer); }
  };
  window.BasicCart = Cart;

  document.addEventListener('click', (e) => {
    const drawer = Cart.drawer;
    if (!drawer || !drawer.contains(e.target)) return;
    const row = e.target.closest('[data-key]');
    if (!row) return;
    const input = $('[data-cart-input]', row);
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) { row.classList.add('is-loading'); Cart.change(row.dataset.key, Math.max(0, Number(input.value) + Number(qtyBtn.dataset.cartQty))); }
    if (e.target.closest('[data-cart-remove]')) {
      row.classList.add('is-loading');
      if (row.dataset.kit) Cart.removeKit(row.dataset.kit);
      else Cart.change(row.dataset.key, 0);
    }
  });
  // Página do carrinho: "Remover kit" tira todas as peças do kit e o brinde
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-kit-remove]');
    if (!btn) return;
    const kitId = btn.closest('[data-kit]').dataset.kit;
    const updates = {};
    $$('.cart-page [data-kit]').forEach((el) => { if (el.dataset.kit === kitId) updates[el.dataset.key] = 0; });
    btn.disabled = true;
    await fetch(T.routes.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
    window.location.reload();
  });
  document.addEventListener('change', (e) => {
    if (!e.target.matches('#CartDrawer [data-cart-input]')) return;
    const row = e.target.closest('[data-key]');
    row.classList.add('is-loading');
    Cart.change(row.dataset.key, Math.max(0, Number(e.target.value)));
  });
  $$('[data-cart-open]').forEach((a) => a.addEventListener('click', async (e) => {
    if (document.body.classList.contains('template-cart')) return;
    e.preventDefault();
    Cart.open();
    Cart.refresh();
  }));

  /* ---------- Compra rápida (cards, vídeos, sacola) ---------- */
  document.addEventListener('click', async (e) => {
    const toggle = e.target.closest('[data-quick-toggle]');
    if (toggle) {
      const card = toggle.closest('.pcard');
      $$('.pcard.is-quick').forEach((c) => { if (c !== card) c.classList.remove('is-quick'); });
      card.classList.toggle('is-quick');
      return;
    }
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    btn.classList.add('is-loading');
    try {
      await Cart.add([{ id: Number(btn.dataset.quickAdd), quantity: 1 }]);
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(() => btn.classList.remove('is-added'), 1200);
      const card = btn.closest('.pcard');
      if (card) card.classList.remove('is-quick');
      Cart.open();
    } catch (err) {
      btn.classList.remove('is-loading');
      btn.title = err.message;
      toast(err.message);
      btn.classList.add('is-error'); setTimeout(() => btn.classList.remove('is-error'), 2500);
    }
  });

  /* ---------- Checkout: sempre pela Yampi (nunca o checkout nativo) ---------- */
  const isCheckoutPath = (href) => {
    try { return /^\/(checkout|checkouts)(\/|$)/.test(new URL(href, window.location.href).pathname); } catch (e) { return false; }
  };
  let checkoutTries = 0;
  const goCheckout = () => {
    if (typeof window.yampiClick === 'function') {
      window.yampiClick();
      // se a Yampi não responder, libera a tela em vez de deixar o carregamento travado
      clearTimeout(goCheckout.guard);
      goCheckout.guard = setTimeout(() => {
        const loader = document.querySelector('.yampi-loader');
        if (loader) loader.style.display = 'none';
        toast('O checkout está demorando para abrir. Tente novamente em instantes.');
      }, 15000);
      return;
    }
    // script da Yampi ainda não carregou: espera um pouco e tenta de novo; nunca envia para /checkout
    if (checkoutTries++ < 10) { setTimeout(goCheckout, 300); return; }
    checkoutTries = 0;
    if (document.body.classList.contains('template-cart')) toast('Não foi possível abrir o checkout. Atualize a página e tente novamente.');
    else window.location.href = (T.routes && T.routes.cart) || '/cart';
  };
  // Na página do carrinho, o script da Yampi redireciona sozinho; se ela não responder, libera a tela
  if (document.body.classList.contains('template-cart')) {
    setTimeout(() => {
      const loader = document.querySelector('.yampi-loader');
      if (loader && getComputedStyle(loader).display !== 'none') {
        loader.style.display = 'none';
        toast('O checkout está demorando para abrir. Toque em Finalizar compra para tentar de novo.');
      }
    }, 15000);
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-checkout]');
    const link = !btn && e.target.closest('a[href]');
    if (btn || (link && isCheckoutPath(link.getAttribute('href')))) {
      e.preventDefault();
      e.stopPropagation();
      goCheckout();
    }
  }, true);
  document.addEventListener('submit', (e) => {
    const sub = e.submitter;
    const action = e.target.getAttribute('action') || '';
    if ((sub && sub.name === 'checkout') || isCheckoutPath(action)) {
      e.preventDefault();
      goCheckout();
    }
  }, true);

  /* ---------- Rodapé: colunas em sanfona só no mobile ---------- */
  const footerCols = $$('.footer__col');
  const syncFooter = () => footerCols.forEach((d) => { d.open = window.innerWidth > 989; });
  footerCols.forEach((d) => d.querySelector('summary').addEventListener('click', (e) => { if (window.innerWidth > 989) e.preventDefault(); }));
  syncFooter();
  let footerW = window.innerWidth;
  window.addEventListener('resize', () => { if ((footerW > 989) !== (window.innerWidth > 989)) syncFooter(); footerW = window.innerWidth; });

  /* ---------- Coleção: ordenação e filtros ---------- */
  const sort = $('[data-sort]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }
  const filterForm = $('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const params = new URLSearchParams();
      new FormData(filterForm).forEach((value, key) => { if (value !== '') params.append(key, value); });
      window.location.search = params.toString();
    });
  }

  /* ---------- Produtos relacionados ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    if (el.children.length) return;
    try {
      const html = await fetch(el.dataset.url).then((r) => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) {
        el.innerHTML = fresh.innerHTML;
        $$('[data-carousel]', el).forEach(initCarousel);
      }
    } catch (_) { /* sem recomendações */ }
  });

  /* ---------- Animações de entrada (Estilo da marca › Animações) ---------- */
  (function initReveal() {
    const B = document.body.dataset;
    const base = B.anim;
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const stagger = 'animStagger' in B;
    const cardsMode = B.animCards || 'same';
    const mediaMode = B.animMedia || 'same';
    const words = 'animWords' in B;
    const CARDS = '.pcard, .catstrip__item, .catgrid__item, .vcard, .wbenefit, .ipage-card, .ipage-step, .product-feature';
    const MEDIA = '.banner-carousel__banner, .vbanner, .promo-grid__item, .colban, .pdesc__media';
    const HEADS = '.section-heading, .vshop__head, .previews__head, .rwall__head, .ipage-head';
    const OTHER = '.marquee, .rwall__rows, .rtext > *, .page-content > *, .ipage-q, .ipage-stat, .full-banner, .product-desc__card, .ipage-cta, .vbanner__content';
    const TITLES = '.section-heading__title, .vshop__title, .previews__title, .rtext__title, .ipage-title';
    const ALL = [CARDS, MEDIA, HEADS, OTHER].join(',');
    const ALL_TYPES = ['fade-up', 'fade', 'zoom', 'blur', 'slide', 'cards-right', 'cards-up', 'mask', 'zoom-in'].map((t) => 'reveal--' + t);

    const esc = (t) => t.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    const split = (el) => {
      if (el.dataset.split || el.children.length || !el.textContent.trim()) return 0;
      const list = el.textContent.trim().split(/\s+/);
      el.dataset.split = '1';
      el.setAttribute('aria-label', el.textContent.trim());
      el.innerHTML = `<span class="wds">${list.map((w, i) => `<span class="wd" aria-hidden="true"><span style="--i:${i}">${esc(w)}</span></span>`).join(' ')}</span>`;
      return list.length;
    };

    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        const el = e.target;
        io.unobserve(el);
        el.classList.add('is-in');
        const dur = (parseFloat(getComputedStyle(el).transitionDuration) || .75) * 1000;
        const total = dur + (parseFloat(el.style.getPropertyValue('--reveal-delay')) || 0) + (Number(el.dataset.words) || 0) * 60 + 900;
        setTimeout(() => { el.classList.remove('reveal', 'is-in', ...ALL_TYPES); el.style.removeProperty('--reveal-delay'); }, total);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0 });

    const setup = (section) => {
      const own = (getComputedStyle(section).getPropertyValue('--anim') || '').trim();
      const type = own || base;
      if (!type || type === 'none') return;
      const units = $$(ALL, section).filter((el) => !el.closest('.hero, .announcement, .site-header, .cart-drawer, .rwall__track, .wbenefits__marquee'));
      const vh = window.innerHeight;
      const counters = new Map();
      units.forEach((el) => {
        if (el.parentElement.closest('.reveal')) return;
        const r = el.getBoundingClientRect();
        if (r.top < vh * 0.9 && r.bottom > 0 && r.left < window.innerWidth) return; // já visível ao carregar
        let t = type;
        let step = stagger ? 80 : 0;
        if (!own && el.matches(CARDS) && cardsMode !== 'same') { t = cardsMode === 'cascade-up' ? 'cards-up' : 'cards-right'; step = 150; }
        else if (!own && el.matches(MEDIA) && mediaMode !== 'same') { t = mediaMode === 'mask' ? 'mask' : 'zoom-in'; step = 0; }
        if (words && el.matches(HEADS)) {
          const n = $$(TITLES, el).reduce((acc, title) => acc + split(title), 0);
          if (n) el.dataset.words = n;
        }
        let delay = 0;
        if (step) {
          const key = el.parentElement;
          const n = counters.get(key) || 0;
          counters.set(key, n + 1);
          delay = Math.min(n, 7) * step;
        }
        el.classList.add('reveal', 'reveal--' + t);
        if (delay) el.style.setProperty('--reveal-delay', delay + 'ms');
        io.observe(el);
      });
    };
    $$('main .shopify-section, .shopify-section-group-footer-group').forEach(setup);
    document.addEventListener('shopify:section:load', (e) => setup(e.target));
  })();

  /* ---------- Faixa em movimento (Barra de benefícios) ---------- */
  (() => {
    // trilho = 2 metades iguais (grupo + clones) que anda -50% em loop; duração vem da velocidade em px/s
    const build = (wrap) => {
      const track = wrap.querySelector('.wbenefits__track');
      const group = track && track.querySelector('.wbenefits__group:not([data-wb-clone])');
      if (!group) return;
      const w = group.offsetWidth;
      if (!w) return;
      const k = Math.max(1, Math.ceil(wrap.offsetWidth / w));
      if (wrap._wbK !== k) {
        $$('[data-wb-clone]', track).forEach((el) => el.remove());
        for (let i = 1; i < k * 2; i++) {
          const clone = group.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('data-wb-clone', '');
          track.appendChild(clone);
        }
        wrap._wbK = k;
      }
      const speed = parseFloat(wrap.dataset.speed) || 45;
      track.style.setProperty('--wb-dur', (k * w / speed).toFixed(2) + 's');
    };
    const init = (root) => $$('[data-wb-marquee]', root).forEach((wrap) => {
      build(wrap);
      if ('ResizeObserver' in window) {
        let last = wrap.offsetWidth;
        new ResizeObserver(() => { if (wrap.offsetWidth !== last) { last = wrap.offsetWidth; build(wrap); } }).observe(wrap);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { wrap._wbK = 0; build(wrap); });
    });
    init(document);
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  /* ---------- Contador da nota (Mural de avaliações) ---------- */
  $$('[data-count-to]').forEach((el) => {
    const to = parseFloat(el.dataset.countTo);
    if (!to || !('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const final = el.textContent;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const t0 = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / 1400);
        const v = to * (1 - Math.pow(1 - p, 3));
        el.textContent = p < 1 ? v.toFixed(1).replace('.', ',') : final;
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.6 });
    io.observe(el);
  });

  /* ---------- Botão de atendimento (FAQ + WhatsApp) ---------- */
  $$('[data-help-float]').forEach((wrap) => {
    const btn = $('[data-help-toggle]', wrap);
    const panel = $('.help-float__panel', wrap);
    const set = (open) => {
      wrap.classList.toggle('is-open', open);
      panel.hidden = !open;
      btn.setAttribute('aria-expanded', String(open));
    };
    btn.addEventListener('click', () => set(!wrap.classList.contains('is-open')));
    document.addEventListener('click', (e) => { if (wrap.classList.contains('is-open') && !wrap.contains(e.target)) set(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') set(false); });
  });

  /* ---------- Cálculo de frete (frete fixo por estado) ---------- */
  (() => {
    const KEY = 'flShipCep';
    const parseMoney = (s) => Math.round(parseFloat(String(s || '').replace(/[^\d,.-]/g, '').replace(/\.(?=\d{3})/g, '').replace(',', '.')) * 100) || 0;
    const rates = (box) => {
      const out = {};
      String(box.dataset.rates || '').split(/\r?\n|;/).forEach((line) => {
        const m = line.match(/([A-Za-z]{2})\s*[:=-]\s*R?\$?\s*([\d.,]+)/);
        if (m) out[m[1].toUpperCase()] = parseMoney(m[2]);
      });
      return out;
    };
    const fmtCep = (v) => { const d = String(v || '').replace(/\D/g, '').slice(0, 8); return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d; };
    let state = null; // { cep, uf }
    try { state = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { state = null; }
    const save = () => { try { if (state) sessionStorage.setItem(KEY, JSON.stringify(state)); else sessionStorage.removeItem(KEY); } catch (e) { /* sem storage */ } };

    const cartTotal = async () => {
      try { const r = await fetch(`${T.routes.cart}.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' }); return (await r.json()).total_price || 0; } catch (e) { return 0; }
    };
    const render = async (box) => {
      const result = $('[data-ship-result]', box);
      const input = $('[data-ship-cep]', box);
      if (!state) { result.hidden = true; result.innerHTML = ''; return; }
      if (input && !input.value) input.value = fmtCep(state.cep);
      const table = rates(box);
      const price = table[state.uf];
      if (price === undefined) { result.hidden = true; showError(box, 'Ainda não temos frete cadastrado para este estado. Fale com a gente no WhatsApp.'); return; }
      const se = String(box.dataset.ufsSe || 'SP,RJ,MG,ES').split(',').map((s) => s.trim());
      const free = parseMoney(se.includes(state.uf) ? box.dataset.freeSe : box.dataset.freeOther);
      let html = `<div class="ship-calc__row"><span>Frete fixo · ${state.uf}</span><strong>${price > 0 ? formatMoney(price) : 'Grátis'}</strong></div>`;
      if (free > 0) {
        html += `<p class="ship-calc__free">Frete grátis em compras a partir de <strong>${formatMoney(free)}</strong>.</p>`;
        if (box.dataset.progress === 'true') {
          const total = await cartTotal();
          if (total > 0) {
            const left = Math.max(0, free - total);
            html += `<div class="ship-calc__progress"><span>${left > 0 ? `Faltam <strong>${formatMoney(left)}</strong> para o frete grátis.` : 'Seu carrinho já tem <strong>frete grátis</strong>.'}</span><i><b style="width: ${Math.min(100, Math.round(total * 100 / free))}%"></b></i></div>`;
          }
        }
      }
      result.innerHTML = html;
      result.hidden = false;
    };
    const showError = (box, msg) => { const el = $('[data-ship-error]', box); el.textContent = msg || ''; el.hidden = !msg; };
    // Barra "Faltam R$ X para frete grátis" da sacola: usa o valor do estado do CEP já calculado
    const renderBar = (bar) => {
      if (!state) return;
      const se = String(bar.dataset.ufsSe || 'SP,RJ,MG,ES').split(',').map((s) => s.trim());
      const free = parseMoney(se.includes(state.uf) ? bar.dataset.freeSe : bar.dataset.freeOther);
      if (!(free > 0)) return;
      const total = +bar.dataset.total || 0;
      const left = Math.max(0, free - total);
      const progress = left > 0 ? Math.round(total * 100 / free) : 100;
      bar.classList.toggle('is-done', left <= 0);
      $('[data-ship-bar-msg]', bar).innerHTML = left > 0
        ? `Faltam <strong>${formatMoney(left)}</strong> para você ganhar <strong>frete grátis</strong> em ${state.uf}`
        : `Uhuul! Você ganhou <strong>frete grátis</strong> em ${state.uf}`;
      const fill = $('.cd-ship__bar span', bar);
      const pin = $('.cd-ship__bar i', bar);
      if (fill) fill.style.width = `${progress}%`;
      if (pin) pin.style.left = `${progress}%`;
    };
    const renderAll = () => { $$('[data-ship-calc]').forEach(render); $$('[data-ship-bar]').forEach(renderBar); };

    document.addEventListener('input', (e) => {
      if (!e.target.matches('[data-ship-cep]')) return;
      e.target.value = fmtCep(e.target.value);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('[data-ship-cep]')) { e.preventDefault(); $('[data-ship-submit]', e.target.closest('[data-ship-calc]')).click(); }
    });
    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-ship-submit]');
      if (!btn) return;
      e.preventDefault();
      const box = btn.closest('[data-ship-calc]');
      const cep = $('[data-ship-cep]', box).value.replace(/\D/g, '');
      showError(box, '');
      if (cep.length !== 8) { showError(box, 'Digite um CEP válido com 8 números.'); return; }
      btn.classList.add('is-loading');
      btn.disabled = true;
      try {
        const ctrl = new AbortController();
        const timer = setTimeout(() => ctrl.abort(), 12000);
        const res = await fetch(`https://viacep.com.br/ws/${cep}/json/`, { signal: ctrl.signal });
        clearTimeout(timer);
        const data = await res.json();
        if (data.erro || !data.uf) { showError(box, 'CEP não encontrado. Confira os números digitados.'); return; }
        state = { cep, uf: String(data.uf).toUpperCase() };
        save();
        $$('[data-ship-calc]').forEach((b) => { const i = $('[data-ship-cep]', b); if (i) i.value = fmtCep(cep); showError(b, ''); });
        renderAll();
      } catch (err) {
        showError(box, err.name === 'AbortError' ? 'A consulta do CEP demorou mais que o esperado. Tente novamente.' : 'Não foi possível consultar o CEP. Tente novamente.');
      } finally {
        btn.classList.remove('is-loading');
        btn.disabled = false;
      }
    });
    document.addEventListener('cart:rendered', renderAll);
    document.addEventListener('shopify:section:load', renderAll);
    renderAll();
  })();

  /* ---------- Tabela de medidas: calculadora (Busto/Cintura/Quadril) ---------- */
  $$('[data-size-calc]').forEach((box) => {
    const scope = box.closest('.drawer') || document;
    const table = $('[data-size-table] table', scope);
    if (!table) return;
    const trs = $$('tr', table);
    if (trs.length < 2) return;
    const norm = (t) => t.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
    const head = Array.from(trs[0].children).map((c) => norm(c.textContent));
    const cols = ['busto', 'cintura', 'quadril'].map((name) => ({ name, idx: head.findIndex((h) => h.includes(name)) })).filter((c) => c.idx > -1);
    const sizeIdx = head.findIndex((h) => h.includes('tam'));
    const rows = trs.slice(1).map((tr) => {
      const cells = Array.from(tr.children).map((c) => c.textContent.trim());
      const r = { size: cells[sizeIdx > -1 ? sizeIdx : 0], ranges: {} };
      cols.forEach((c) => {
        const m = (cells[c.idx] || '').match(/(\d+(?:[.,]\d+)?)\s*(?:[-–]|a|até)\s*(\d+(?:[.,]\d+)?)/);
        if (m) r.ranges[c.name] = [parseFloat(m[1].replace(',', '.')), parseFloat(m[2].replace(',', '.'))];
      });
      return r;
    }).filter((r) => r.size && Object.keys(r.ranges).length);
    // Sem coluna de tamanho (tabela só com medidas) não dá para indicar um tamanho
    if (!cols.length || !rows.length || sizeIdx < 0) return;
    const labels = { busto: 'Busto', cintura: 'Cintura', quadril: 'Quadril' };
    $('[data-size-calc-fields]', box).innerHTML = cols.map((c) => `<label class="size-calc__field"><span>${labels[c.name]}</span><span class="size-calc__input"><input type="number" inputmode="decimal" min="40" max="200" step="1" placeholder="—" data-calc="${c.name}"><em>cm</em></span></label>`).join('');
    const result = $('[data-size-calc-result]', box);
    const form = $('[data-product-form]');
    const findInput = (size) => form && $$('.product-option input[type="radio"]', form).find((i) => i.value.trim() === size);
    const update = () => {
      const vals = {};
      $$('[data-calc]', box).forEach((inp) => { const v = parseFloat(inp.value); if (v > 0) vals[inp.dataset.calc] = v; });
      const keys = Object.keys(vals);
      if (!keys.length) { result.innerHTML = '<span class="size-calc__hint">Coloque suas medidas para ver o tamanho indicado.</span>'; return; }
      const fits = (r, strict) => keys.every((k) => { const g = r.ranges[k]; return !g || (strict ? vals[k] >= g[0] && vals[k] <= g[1] : vals[k] <= g[1]); });
      const exact = rows.filter((r) => fits(r, true));
      const best = exact.length ? exact[exact.length - 1] : rows.find((r) => fits(r, false));
      if (!best) { result.innerHTML = '<span class="size-calc__hint">Suas medidas passam da nossa tabela. Fale com a gente no WhatsApp que a gente te ajuda.</span>'; return; }
      let out = `<span class="size-calc__size">Seu tamanho: <b>${best.size}</b></span>`;
      if (exact.length > 1) out += `<span class="size-calc__hint">Ficou entre ${exact[0].size} e ${best.size}: indicamos o maior para mais conforto.</span>`;
      if (findInput(best.size)) out += `<button type="button" class="size-calc__use" data-size-use="${best.size}">Usar o tamanho ${best.size}</button>`;
      result.innerHTML = out;
    };
    box.addEventListener('input', update);
    result.addEventListener('click', (e) => {
      const b = e.target.closest('[data-size-use]');
      if (!b) return;
      const input = findInput(b.dataset.sizeUse);
      if (!input) return;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      closeDrawer(box.closest('.drawer'));
    });
    box.hidden = false;
    update();
  });

  /* ---------- Como veste: comparador arrastável ---------- */
  $$('[data-compare]').forEach((el) => {
    const range = $('[data-compare-range]', el);
    if (!range) return;
    const set = () => el.style.setProperty('--pos', `${range.value}%`);
    range.addEventListener('input', set);
    set();
  });

  /* ---------- Kit · avaliações: carrossel ---------- */
  $$('[data-rv]').forEach((el) => {
    const track = $('[data-rv-track]', el);
    const prev = $('[data-rv-prev]', el);
    const next = $('[data-rv-next]', el);
    if (!track || !prev || !next) return;
    const step = () => { const item = track.firstElementChild; return item ? item.getBoundingClientRect().width + 12 : track.clientWidth; };
    const sync = () => {
      const max = track.scrollWidth - track.clientWidth - 2;
      el.classList.toggle('is-static', max <= 0);
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    };
    prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(sync), { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
  /* ---------- Cores do modelo (página do produto): 1 linha deslizando ----------
     Selo "+N cores" na ponta conta as cores escondidas à direita (clique desliza);
     na 1ª vez que aparece, as cores "puxam" para o lado mostrando que dá para arrastar. */
  $$('[data-pcolors]').forEach((el) => {
    const row = $('[data-pcolors-list]', el);
    const badge = $('[data-pcolors-more]', el);
    if (!row || !badge) return;
    const active = $('.is-active', row);
    // cor aberta perto da ponta (embaixo do degradê/selo): rola até ela, deixando 1 cor anterior à vista
    if (active) {
      const r = row.getBoundingClientRect();
      const a = active.getBoundingClientRect();
      if (a.right > r.right - 90) row.scrollLeft += a.left - r.left - a.width - 12;
    }
    const update = () => {
      if (!row.offsetParent) return;
      const edge = row.getBoundingClientRect().right - 16;
      let n = 0;
      row.querySelectorAll('.pcolors__item').forEach((c) => { if (c.getBoundingClientRect().left + c.offsetWidth * 0.5 > edge) n++; });
      badge.hidden = n < 1;
      badge.textContent = `+${n} ${n === 1 ? 'cor' : 'cores'}`;
      badge.setAttribute('aria-label', `Ver mais ${n} ${n === 1 ? 'cor' : 'cores'}`);
    };
    let raf;
    let touched = false;
    row.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
    // só toque/roda/clique da cliente contam como "já mexeu" (a rolagem até a cor aberta, acima, não)
    ['pointerdown', 'wheel', 'touchstart'].forEach((t) => row.addEventListener(t, () => { touched = true; row.classList.remove('is-nudge'); }, { passive: true }));
    badge.addEventListener('click', () => row.scrollBy({ left: row.clientWidth * 0.8, behavior: 'smooth' }));
    window.addEventListener('resize', update);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        update();
        io.disconnect();
        if (touched || row.scrollWidth - row.clientWidth < 8 || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        setTimeout(() => {
          if (touched) return;
          row.classList.add('is-nudge');
          setTimeout(() => row.classList.remove('is-nudge'), 1700);
        }, 350);
      }, { threshold: 0.7 });
      io.observe(row);
    }
    update();
  });
})();
